namespace TabAurous.Purchase {
    export interface PurchaseReturnMasterForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        GstVat: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: PurchaseReturnItemsEditor;
        TaxDetails: PurchaseReturnTaxEditor;
        ShipmentId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        CCTaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        RoundOff: Serenity.DecimalEditor;
        CCRoundOff: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class PurchaseReturnMasterForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PurchaseReturnMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PurchaseReturnMasterForm.init)  {
                PurchaseReturnMasterForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.TextAreaEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = PurchaseReturnItemsEditor;
                var w9 = PurchaseReturnTaxEditor;

                Q.initFormType(PurchaseReturnMasterForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'PartyId', w4,
                    'LedgerName', w2,
                    'Address1', w5,
                    'State', w2,
                    'Country', w2,
                    'TermsId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'CurrencyId', w4,
                    'ExchRate', w6,
                    'GstVat', w2,
                    'UserId', w4,
                    'EmployeeId', w3,
                    'ProductItemImage', w7,
                    'ItemDetails', w8,
                    'TaxDetails', w9,
                    'ShipmentId', w3,
                    'Pieces', w3,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'CCNetAmount', w6,
                    'TaxAmount', w6,
                    'CCTaxAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'RoundOff', w6,
                    'CCRoundOff', w6,
                    'GrossAmount', w6,
                    'CCGrossAmount', w6,
                    'Remark', w5,
                    'ShipAddressId', w3,
                    'FinancialYearId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
